export const filterArrayWithSelectedObject = (array, selectedObject) =>
    array &&
    array?.length > 0 &&
    array?.filter((item) => {
        if (selectedObject && Object?.values(selectedObject).length > 0) {
            if (!Object?.values(selectedObject).includes(Number(item?.value))) {
                return item;
            }
        } else return array;
    });
